import type { Placement } from '@popperjs/core'
import type { ReactNode } from 'react'
import FieldsetDescriptionButton from '../FieldsetDescriptionButton/FieldsetDescriptionButton'
import PopOut from '../PopOut/PopOut'
import classes from './InfoPopOut.module.scss'

export interface Props {
  children: ReactNode
  placement?: Placement
  variant?: 'widerWidth' | ''
}

const triggerInfoButton = (ref: any, onClick: () => void) =>
  <FieldsetDescriptionButton
    onClick={onClick}
    ref={ref}
  />

const InfoPopOut = ({
  children,
  placement = 'auto',
  variant = ''
}: Props) =>
  <PopOut
    placement={placement}
    trigger={triggerInfoButton}
  >
    <div className={classes.InfoPopOut + ' ' + classes[variant]}>
      {children}
    </div>
  </PopOut>

export default InfoPopOut
